import {
  AbcCommentsListComponent,
  ImageViewerComponent,
  PropertiesEditorFormComponent,
} from '@barthauer/abc/common-editors';
import {
  AbcDateBoxComponent,
  AbcDocumentInputComponent,
  AbcDropDownBoxComponent,
  AbcEditorComponent,
  AbcHtmlEditorComponent,
  AbcNumberBoxComponent,
  AbcTextBoxComponent,
  _AbcCheckBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';

export type AbcComponent = StandardComponent | PDC;

export type PDC =
  | AbcCommentsListComponent
  | AbcDocumentInputComponent
  | AbcEditorComponent
  | ImageViewerComponent
  | PropertiesEditorFormComponent;

export type StandardComponent =
  | AbcDropDownBoxComponent
  | AbcTextBoxComponent
  | AbcNumberBoxComponent
  | AbcDateBoxComponent
  | _AbcTextAreaComponent
  | _AbcCheckBoxComponent
  | AbcHtmlEditorComponent;

export enum MenuButton {
  Delete = 'Delete',
  Add = 'Add',
  Save = 'Save',
  Undo = 'Undo',
  Report = 'Report',
  DmlQuery = 'DmlQuery',
}
